export default class FormError extends Error {
  constructor(message) {
    super(String(message));
  }
}
flarum.reg.add('fof-polls', 'forum/components/form/FormError', FormError);